import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Crown, ChevronLeft } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const GOLD = '#c9a962';
const INK = '#14100e';

export default function FoundersWallPage() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/founding-ten/wall`).then(r => r.json()).then(setData).catch(() => {});
  }, []);

  const winners = data?.winners || [];
  const slots = Array.from({ length: 10 }, (_, i) => winners.find(w => w.rank === i + 1) || null);

  return (
    <div className="min-h-screen pb-16" style={{ backgroundColor: INK }} data-testid="founders-wall-page">
      <meta name="robots" content="index, follow" />
      <div className="max-w-lg mx-auto px-6 pt-8">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-xs mb-8" style={{ color: '#a89a8c' }} data-testid="founders-wall-back">
          <ChevronLeft className="w-4 h-4" /> Back
        </button>
        <div className="text-center mb-10">
          <Crown className="w-10 h-10 mx-auto mb-3" style={{ color: GOLD }} />
          <p className="text-[11px] tracking-[0.3em] uppercase mb-2" style={{ color: GOLD }}>Minted</p>
          <h1 className="text-4xl sm:text-5xl" style={{ fontFamily: 'Georgia, serif', color: '#f0e9df' }}>The Founders Wall</h1>
          <p className="text-sm mt-3" style={{ color: '#a89a8c' }}>
            Ten names. Engraved in Minted history, permanently.
          </p>
          {data && data.slots_left > 0 && (
            <p className="text-xs mt-2" style={{ color: GOLD }} data-testid="founders-wall-slots">{data.slots_left} slots still unclaimed</p>
          )}
        </div>
        <div className="space-y-3">
          {slots.map((w, i) => (
            <div key={i} className="flex items-center gap-4 rounded-lg px-5 py-4" style={{ backgroundColor: w ? 'rgba(201,169,98,0.08)' : 'rgba(255,255,255,0.03)', border: `1px solid ${w ? 'rgba(201,169,98,0.4)' : 'rgba(255,255,255,0.06)'}` }} data-testid={`founders-wall-slot-${i + 1}`}>
              <span className="text-lg w-8" style={{ fontFamily: 'Georgia, serif', color: w ? GOLD : '#3d352c' }}>#{i + 1}</span>
              {w ? (
                <div>
                  <p className="text-base" style={{ fontFamily: 'Georgia, serif', color: '#f0e9df' }}>{w.name}</p>
                  <p className="text-[10px]" style={{ color: '#a89a8c' }}>Founding Ten · claimed {new Date(w.claimed_at).toLocaleDateString()}</p>
                </div>
              ) : (
                <p className="text-sm italic" style={{ color: '#5a5048' }}>Unclaimed</p>
              )}
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <button onClick={() => navigate('/profile')} className="text-xs font-semibold px-6 py-3 rounded-lg" style={{ backgroundColor: GOLD, color: INK }} data-testid="founders-wall-cta">
            View my challenge tracker
          </button>
        </div>
      </div>
    </div>
  );
}
